import React from "react";
import { Alert, Button } from "react-bootstrap";
import { FaIcon } from "lib/FaIcon";

export const TextAlert = ({ heading = "", title = "", icon = "fa fa-info-circle", onDismiss }) => (
  <Alert variant="info rounded-pill d-flex flex-row align-items-center">
    <FaIcon icon={"fa-2x mr-3 " + icon} />
    <article className="flex-grow-1">
      {heading && <Alert.Heading style={{ fontSize: "16px" }}>{heading}</Alert.Heading>}
      <div>{title}</div>
    </article>
    <Button variant="link text-dark ml-auto" onClick={onDismiss}>
      <FaIcon icon="fa fa-times mr-1" />
    </Button>
  </Alert>
);
